import { getWithToken } from "../authentication/AuthProvider";
import { apiUrl } from "../config";

const published_template = apiUrl + "/published_template";
const routes = {
  label: "Published Template",
  root: published_template,
  get_all: published_template + "/get_all",
};
export const PublishedTemplate = {
  label: routes.label,
  get_all: () => getWithToken(routes.get_all),
};
